var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            path\n            {\n                fill: #263c53;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.74,79.1,176.32,79a68.59,68.59,0,0,1-32.93-8.55l-25.6-14.17A83.48,83.48,0,0,0,77.44,45.84H28.13l-.24,127.45H77.25a68.42,68.42,0,0,1,33.09,8.55L135.92,196a83.6,83.6,0,0,0,40.16,10.43l49.44.12ZM210.55,191.51l-34.43-.08a67.89,67.89,0,0,1-12-1.1l.07-38.63-15-7.51-.08,41.61q-3-1.32-5.94-2.92l-25.58-14.17a83.13,83.13,0,0,0-13.27-5.89l.07-41.09-15-7.52-.07,45a83,83,0,0,0-12.1-.88H42.92l.18-97.45H77.44a67.64,67.64,0,0,1,12.07,1.08l-.06,35.52,15,7.52.06-38.53c2.06.88,4.07,1.87,6,2.95l25.6,14.17a82.06,82.06,0,0,0,13.18,5.86l-.07,38,15,7.52.08-41.86a84.08,84.08,0,0,0,12,.9l34.43.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumble);
export default __webpack_public_path__ + "static/media/humble.815260499fc258612cea1f675b462169.svg";
export { ForwardRef as ReactComponent };